import Swal from "sweetalert2";
// import { useDarkMode } from "usehooks-ts";

function inIframe() {
    if (window.location.search === "?inIframe=1") {
        return true;
    }
    try {
        document.body.classList.add("iframe");
        return window.self !== window.top;
    } catch (e) {
        document.body.classList.add("inIframe");
        return true;
    }
}
function getDarkMode() {
    const currentLocalStorageTheme = inIframe() ? "light" : localStorage.getItem("theme");
    if (currentLocalStorageTheme !== null) {
        if (currentLocalStorageTheme === "dark") {
            return true;
        } else {
            return false;
        }
    } else {
        // Couldn't find theme in local storage
        // console.error("Theme not stored");
        if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
            return true;
        } else {
            return false;
        }
    }
}

export default function SwalNeogenFire(config: any) {
    // This function wraps the Swal alerts and provides exactly the same functionality
    // as the original Swal with the exception of providing dark mode support.
    if (config.darkMode || (getDarkMode() && config.darkMode !== false)) {
        // If dark mode is enabled, we need to override the default Swal styling
        // with our own dark mode styling.
        const { icon, ...rest } = config;
        const darkModeConfig = {
            ...rest,
            icon: icon || "info",
            customClass: {
                container: "dark:bg-gray-800 dark:text-gray-100",
                popup: "dark:bg-gray-800 dark:text-gray-100",
                header: "dark:bg-gray-800 dark:text-gray-100",
                title: "dark:bg-gray-800 dark:text-gray-100",
                closeButton: "dark:bg-gray-800 dark:text-gray-100",
                icon: "dark:bg-gray-800 dark:text-gray-100",
                image: "dark:bg-gray-800 dark:text-gray-100",
                content: "dark:bg-gray-800 dark:text-gray-100",
                input: "dark:bg-gray-800 dark:text-gray-100",
                actions: "dark:bg-gray-800 dark:text-gray-100",
                confirmButtonText: "dark:bg-gray-800 dark:text-gray-100",
                cancelButtonText: "dark:bg-gray-800 dark:text-gray-100",
                confirmButton: "dark:bg-gray-800 dark:text-gray-100",
                cancelButton: "dark:bg-gray-800 dark:text-gray-100",
                footer: "dark:bg-gray-800 dark:text-gray-100",
            },
        };
        return Swal.fire(darkModeConfig);
    }

    const {
        title,
        text,
        icon,
        confirmButtonText,
        showCancelButton,
        cancelButtonText,
        showLoaderOnConfirm,
        preConfirm,
        onConfirm,
        onCancel,
        ...rest
    } = config;

    return Swal.fire({
        title,
        text,
        icon,
        confirmButtonText,
        showCancelButton,
        cancelButtonText,
        showLoaderOnConfirm,
        preConfirm,
        onConfirm,
        onCancel,
        ...rest,
    });
}

type SwalProps = {
    title: string;
    text: string;
    type: "success" | "error" | "warning" | "info" | "question";
    showCancelButton: boolean;
};
